import { fetchAllStockOpname } from "../../resources/StockOpnameResource";
import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { format } from "date-fns";
import { getLocalAuth } from "../../utils/AuthUtils";
import ErrorNotFound from "../errors/Error";
import { createOutbound } from "../../resources/OutboundResource";
import { showSuccessToast } from "../../utils/GlobalToast";
import { fetchAllRack } from "../../resources/RackResource";
import Select from "react-select";

function StockOpname() {
  const values = getLocalAuth();
  const profile = JSON.parse(values.authLocal);
  const privilege = JSON.parse(values.authPrivilege);

  let dataPrivilege = privilege.data.menu.filter((data) => {
    return data.code === "Stock Opname";
  });

  let dataRead =
    dataPrivilege.length === 0
      ? []
      : dataPrivilege[0].action_page.filter((data) => {
          return data.code === "Read";
        });

  const [dataStockOpname, setDataStockOpname] = useState([]);
  const [dateFilter, setDateFilter] = useState(
    format(new Date(), "yyyy-MM-dd").toString()
  );
  const [dataRack, setDataRack] = useState([]);
  const [rackId, setRackId] = useState("default");

  const [refreshKey, setRefreshKey] = useState(0);

  const [showOutboundModal, setShowOutboundModal] = useState(false);

  const [isErrorOutbound, setIsErrorOutbound] = useState(false);
  const [errorOutbound, setErrorOutbound] = useState("");

  const [isLoading, setIsLoading] = useState(false);

  const fetchStockOpname = (rackId) => {
    fetchAllStockOpname(
      dateFilter === "" ? "" : format(dateFilter, "yyyy-MM-dd").toString(),
      rackId === "default" ? "" : rackId.value
    )
      .then((res) => {
        setDataStockOpname(res.data.rfids);
      })
      .catch((err) => {
        setDataStockOpname([]);
      });
  };

  const fetchRack = () => {
    fetchAllRack()
      .then((res) => {
        setDataRack(res.data);
      })
      .catch((err) => {
        setDataRack([]);
      });
  };

  useEffect(() => {
    fetchStockOpname(rackId);
    fetchRack();
    // eslint-disable-next-line
  }, [refreshKey]);

  let dataRackSelect = dataRack.map(function (data) {
    return { value: data.id, label: data.name };
  });

  const handleOutbound = (part, rfid, qty) => {
    let outboundItem = [
      {
        part: part,
        rfid: rfid,
        qty: qty,
      },
    ];
    setIsLoading(true);
    createOutbound("Missing Part", profile.data.privilege_id, outboundItem)
      .then((res) => {
        setIsLoading(false);
        setIsErrorOutbound(false);
        showSuccessToast("Success Added Outboundd");
        setShowOutboundModal(false);
        fetchStockOpname(rackId);
      })
      .catch((err) => {
        setIsLoading(false);
        setErrorOutbound(err);
        setIsErrorOutbound(true);
      });
  };

  const onChangeHandlerRack = (options) => {
    setRackId(options);

    setRefreshKey((refreshKey) => refreshKey + 1);
  };

  const columns = [
    {
      name: "No",
      cell: (row, index) => index + 1,
      width: "60px",
    },
    // {
    //   name: 'Date',
    //   selector: row => row.date === null ? '-' : format(row.date, "yyyy-MM-dd").toString(),
    //   sortable: true,
    // },
    {
      name: "RFID No",
      selector: (row) => (row.rfid_number === null ? "-" : row.rfid_number),
      sortable: true,
    },
    {
      name: "RFID Name",
      selector: (row) => (row.name === null ? "-" : row.name),
      sortable: true,
    },
    {
      name: "Part No",
      selector: (row) => (row.part_number === null ? "-" : row.part_number),
      sortable: true,
    },
    {
      name: "Part Name",
      selector: (row) => (row.part_name === null ? "-" : row.part_name),
      sortable: true,
    },
    {
      name: "Batch",
      selector: (row) => (row.batch === null ? "-" : row.batch),
      sortable: true,
    },
    {
      name: "QTY",
      selector: (row) => (row.qty === null ? 0 : row.qty),
      sortable: true,
    },
    // {
    //   name: 'Stock',
    //   selector: row => row.stock === null ? 0 : row.stock,
    //   sortable: true,
    // },
    {
      name: "Rack",
      selector: (row) => (row.rack === null ? 0 : row.rack.name),
      sortable: true,
    },
    {
      name: "Scan Date",
      selector: (row) =>
        row.datetime_scan === null
          ? "-"
          : format(row.datetime_scan, "yyyy-MM-dd HH:mm").toString(),
      sortable: true,
      width: "180px",
    },
    {
      name: "Created At",
      selector: (row) =>
        row.created_at === null
          ? "-"
          : format(row.created_at, "yyyy-MM-dd HH:mm").toString(),
      sortable: true,
      width: "180px",
    },
    {
      name: "Updated At",
      selector: (row) =>
        row.updated_at === null
          ? "-"
          : format(row.updated_at, "yyyy-MM-dd HH:mm").toString(),
      sortable: true,
      width: "180px",
    },
    {
      name: "Actions",
      cell: (row) => (
        <>
          {!row.is_scanned ? (
            <div>
              <button
                type="button"
                style={{ marginRight: "8px" }}
                className="btn btn-info"
                onClick={() => {
                  setShowOutboundModal(true);
                }}
              >
                Outbound
              </button>
              <div
                className={`modal fade ${showOutboundModal ? "show" : ""}`}
                style={{
                  display: showOutboundModal ? "block" : "none",
                  backgroundColor: "rgba(0, 0, 0, 0.1)",
                }}
              >
                <div className="modal-dialog">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">Outbound this item?</h5>
                      <button
                        type="button"
                        className="btn-close"
                        onClick={() => setShowOutboundModal(false)}
                        aria-label="Close"
                      ></button>
                    </div>
                    {isErrorOutbound ? (
                      <div
                        style={{
                          paddingLeft: "16px",
                          paddingRight: "16px",
                          paddingTop: "16px",
                          paddingBottom: "0px",
                        }}
                      >
                        <div
                          className="alert alert-danger alert-dismissible fade show"
                          role="alert"
                        >
                          {errorOutbound}
                          <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="alert"
                            aria-label="Close"
                            onClick={() => setIsErrorOutbound(false)}
                          ></button>
                        </div>
                      </div>
                    ) : null}
                    <div className="modal-body">
                      {`You will outbound this item`}
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => setShowOutboundModal(false)}
                      >
                        Cancel
                      </button>
                      {!isLoading ? (
                        <button
                          type="submit"
                          className="btn btn-info"
                          onClick={() =>
                            handleOutbound(
                              row.part_number,
                              row.rfid_number,
                              row.qty
                            )
                          }
                        >
                          Outbound
                        </button>
                      ) : (
                        <button
                          className="btn btn-danger"
                          type="button"
                          disabled
                        >
                          {" "}
                          <span
                            style={{ marginRight: "4px" }}
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          Loading...
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : null}
        </>
      ),
    },
  ];
  return (
    <div>
      {dataRead.length === 0 ? (
        <ErrorNotFound />
      ) : !dataRead[0].is_active ? (
        <ErrorNotFound />
      ) : (
        <div className="page-content-wrapper">
          <div className="page-content">
            <div className="card">
              <div className="card-body">
                <div className="card-title">
                  <h4 className="mb-0">Stock Opname</h4>
                </div>
                <hr />
                <div className="row">
                  <div className="col-md-3">
                    <label className="form-label">Date:</label>
                    <input
                      type="date"
                      className="form-control"
                      value={dateFilter}
                      onChange={(e) => {
                        setDateFilter(e.target.value);
                        setRefreshKey((refreshKey) => refreshKey + 1);
                      }}
                    />
                  </div>
                  <div className="col-md-3">
                    <label className="form-label fw-bold">Rack Location</label>
                    <Select
                      value={rackId}
                      onChange={onChangeHandlerRack}
                      options={dataRackSelect}
                    />
                  </div>
                </div>
                <br />
                <div className="table-responsive">
                  {!dataStockOpname ? (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "260px",
                      }}
                    >
                      <div
                        className="spinner-border text-primary"
                        role="status"
                      >
                        {" "}
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  ) : dataStockOpname.length === 0 ? (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "260px",
                      }}
                    >
                      <div>
                        <span>Data is Empty</span>
                      </div>
                    </div>
                  ) : (
                    <DataTable
                      columns={columns}
                      data={dataStockOpname}
                      pagination
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default StockOpname;
